module.exports = __webpack_public_path__ + "static/media/4ODA4.bed569f4.jpg";